export enum ExchangeCategoryType {
    exchange = 1,
    fancyBat = 2,
    premium = 4,
    bookmaker = 5,
}